import mod from "-!./changePassword.js?vue&type=script&lang=js&"; export default mod; export * from "-!./changePassword.js?vue&type=script&lang=js&"